import { ApiKnowledgeDocumentService } from '.';
import { AxiosResponse } from 'axios';
import { HttpMethods } from '../httpMethods';
import { Controllers, KnowledgeDocumentApiRoutes } from '../../utils/constants';
import { BaseService } from '../baseService';
import { KnowledgeDocumentDto } from 'src/types/knowledgeDocument';

export class KnowledgeDocumentService extends BaseService implements ApiKnowledgeDocumentService {
    async getKnowledgeDocuments(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.KnowledgeDocument, '', urlParams);
    }

    async getAllKnowledgeDocuments(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.KnowledgeDocument, 'list');
    }

    async deleteKnowledgeDocuments(ids: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.KnowledgeDocument, 'delete', '', ids);
    }

    async getKnowledgeDocumentById(id: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.KnowledgeDocument, id);
    }

    async uploadDocument(documentId: string, data: FormData): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.KnowledgeDocument, KnowledgeDocumentApiRoutes.Upload(documentId), '', data);
    }

    async deleteUploadedDocument(documentId: string, fileName: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.KnowledgeDocument, KnowledgeDocumentApiRoutes.DeleteFile(documentId), '', fileName);
    }

    async createKnowledgeDocument(data: KnowledgeDocumentDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.KnowledgeDocument, 'create', '', data);
    }

    async updateKnowledgeDocument(id: string, data: KnowledgeDocumentDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.KnowledgeDocument, `update/${id}`, '', data);
    }
}
